import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import PortalVue from 'portal-vue';

import CountryFlag from 'vue-country-flag';
import VueCookies from 'vue-cookies';
import '@mdi/font/css/materialdesignicons.css';

Vue.component('country-flag', CountryFlag);
//Check are there some way to check build mode here. If not remember to change
Vue.config.productionTip = false;
Vue.config.productionGzip = false;
Vue.use(VueCookies);
Vue.use(PortalVue);
Vue.prototype.$log = console.log;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
